<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex"
export default {
	methods: {
		...mapActions("login", ["LOGOUT_USER"]),
		...mapActions(["GET_MY_PROFILE"]),
		...mapMutations(["SET_FRIEND_STATUS"]),
		...mapMutations("sockets", ["ADD_MESSAGE"])
	},

	computed: {
		...mapState(["MY_PROFILE"]),
		...mapGetters(["MY_FRIENDS"])
	},
	mounted() {
		if (this.$router.currentRoute.path === "/") {
			this.$router.push({ name: "index" })
		}
	},
	sockets: {
		connect() {
			console.log(this.$socket.id)
		},
		friendConnected({ nickname }) {
			this.SET_FRIEND_STATUS({ isOnline: true, nickname })
		},
		friendDisconnected({ nickname }) {
			this.SET_FRIEND_STATUS({ isOnline: false, nickname })
		},
		showFriendStatus({ friends }) {
			friends.forEach((friend) => {
				this.SET_FRIEND_STATUS({
					isOnline: true,
					nickname: friend.nickname
				})
			})
		}
	}
}
</script>
<style lang="scss">
@import "./assets/styles/scss/theme/index.scss";
@import "./assets/styles/scss/auth/forms.scss";
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

#nav {
	padding: 30px;
}

#nav a {
	font-weight: bold;
	color: #2c3e50;
}

#nav a.router-link-exact-active {
	color: var(--primary-color-lightened);
}
</style>
